<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="countryList">
          <div class="country">
              <span>河道水情报表：</span>
          </div>
          <div class="country" v-for="(item,index) in rainstatis" :key="index" @click="navcheck(item,index,item.type)">
              <span :class="{'countryon':index==choosed}">{{item.name}}</span>
          </div>
      </div>
      <component :is="activeComponent"></component>
    </div>
  </div>
</template>
<script>
import WaterLevelStatistics from './waterLevelStatistics'
export default {
  name: 'MonitoringCenter',
  components: {
    WaterLevelStatistics
  },
  data () {
    return {
      activeComponent: 'WaterLevelStatistics',
      rainstatis: [
        { name: '时段水位统计', type: 'ReservoirWaterLevelStatistics' }
      ],
      choosed: 0
    }
  },
  computed: {
  },
  methods: {
    navcheck: function (item, index, type) {
      this.choosed = index
      // console.log(type)
      this.activeComponent = type
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
